import reduxStore from 'redux/store';
import {VALUES as demandStatus} from 'constants/ProcedureStatus';
import {ProcedureType_PZP_2021} from '../constants/ProcedureType';
import PZPType from '../constants/PZPType';
import {isEuropeProcedure as isEuProc, isNationalProcedure as isNatProc, isNonpublicProcedure as isNonpubProc} from 'constants/ProcedureType'

export const wasEverPublished = () => {
    const {resources} = reduxStore.getState();
    const result = resources.demandHeader ? demandStatus.PREPARING !== resources.demandHeader.status : undefined;
    return result;
}

export const isDemandNew = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? resources.demandHeader.status === null : false;
}

export const isDemandPreparing = () => {
    const {resources} = reduxStore.getState();
    if (resources.demandHeader) {
        return !resources.demandHeader.status || demandStatus.PREPARING === resources.demandHeader.status
    } else {
        if (resources.demand) {
            return resources.demand.identity === -1 ? true : undefined;
        } else {
            return undefined;
        }
    }
}

export const previewDemandPublicFormDisabled = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ?
        resources.demandHeader.demandRealizationType === 'rfq_no_invitation' || resources.demandHeader.demandRealizationType === 'public_exclusion_closed'
        : undefined;
}

export const isDemandModification = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? demandStatus.MODIFICATION === resources.demandHeader.status : undefined;
}
export const isDemandOfferCollection = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? demandStatus.OFFER_COLLECTION === resources.demandHeader.status : undefined;
}

export const isDemandOfferDecryption = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? demandStatus.OFFER_DECRYPTION === resources.demandHeader.status : undefined;
}

export const isDemandOfferEvaluation = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? demandStatus.OFFER_EVALUATION === resources.demandHeader.status : undefined;
}

export const isDemandFinishing = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? demandStatus.FINISHING === resources.demandHeader.status : undefined;
}

export const isDemandFinished = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? demandStatus.FINISHED === resources.demandHeader.status : undefined;
}

export const getDemandPZPType = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? (ProcedureType_PZP_2021.includes(resources.demandHeader.procedureType) ? PZPType.PZP_2021 : PZPType.PZP_OLD) : undefined;
}

export const isNonpublicProcedure = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? isNonpubProc(resources.demandHeader.procedureType) : undefined;
}
export const isNationalProcedure = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? isNatProc(resources.demandHeader.procedureType) : undefined;
}
export const isEuropeProcedure = () => {
    const {resources} = reduxStore.getState();
    return resources.demandHeader ? isEuProc(resources.demandHeader.procedureType) : undefined;
}